import { AsYouType } from 'libphonenumber-js/min';
import type { CustomerContactInput } from '@/lib/validation/manualStopValidation';
import type { AddressValidationResult } from '@/types/manualStops';

export const EMPTY_CUSTOMER_CONTACT: CustomerContactInput = {
  first_name: '',
  last_name: '',
  phone_e164: '',
  email: '',
  preferred_contact: 'call'
};

/** USPS-standardized address as one line: "123 MAIN ST, APT 4, AUSTIN, TX 78701-1234". */
export function formatStandardized(s: NonNullable<AddressValidationResult['standardized']>) {
  const zip = s.zip4 ? `${s.zip5}-${s.zip4}` : s.zip5;
  return [s.line1, s.line2, `${s.city}, ${s.region} ${zip}`].filter(Boolean).join(', ');
}

/** A US number has 10 digits, or 11 with the leading country code 1. */
const maxPhoneDigits = (digits: string) => (digits.startsWith('1') ? 11 : 10);

/**
 * Format "5128675309" → "(512) 867-5309" while typing and refuse digits past a
 * full US number. The schema converts the result to E.164 on submit.
 */
export const formatPhoneAsTyped = (raw: string, previous: string): string => {
  // Let backspace remove formatting characters without the formatter re-adding them.
  if (raw.length < previous.length) return raw;
  const digits = raw.replace(/\D/g, '');
  if (digits.length > maxPhoneDigits(digits)) return previous;
  return new AsYouType('US').input(raw);
};
